function createScreenLock() {
  function isScreenLockSupported() {
    return "wakeLock" in navigator;
  }

  let screenLock;

  function getScreenLock() {
    if (isScreenLockSupported()) {
      console.log("wakeLock Supported");
      try {
        navigator.wakeLock.request("screen").then((lock) => {
          screenLock = lock;
          console.log("Locked!!!");
        });
      } catch (err) {
        console.log(err.name, err.message);
      }
    } else {
      console.log("wakeLock NOT Supported");
    }
  }

  function addVisibilityListener() {
    document.addEventListener("visibilitychange", onVisibilityChange);
  }

  function removeVisibilityListener() {
    document.removeEventListener("visibilitychange", onVisibilityChange);
  }

  function onVisibilityChange() {
    console.log("onVisibilityChange!!!");
    if (screenLock !== null && document.visibilityState === "visible") {
      getScreenLock();
    }
  }

  function release() {
    if (typeof screenLock !== "undefined" && screenLock != null) {
      screenLock.release().then(() => {
        console.log("Lock released 🎈");
        screenLock = null;
      });
    }
  }

  return {
    getScreenLock,
    release,
    addVisibilityListener,
    removeVisibilityListener,
  };
}

export const screenLock = createScreenLock();
